export enum PlayerState {
  PAUSED,
  LOADING,
  PLAYING,
  NOT_INITIALIZED,
}
